let solanaSdk = null;

export async function initSDK({ rpcUrl }) {
  const { Connection } = await import('@solana/web3.js');
  solanaSdk = new Connection(rpcUrl, 'confirmed');
}

export function getSDK() {
  if (!solanaSdk) throw new Error("Solana SDK not initialized");
  return solanaSdk;
}